
import { Home, FileText, Users, MessageSquare, Settings, CreditCard, ShieldCheck, BadgeDollarSign } from "lucide-react";

export type SidebarIconName = 
  | "Dashboard" 
  | "Investor Forms" 
  | "Investor Leads" 
  | "Campaigns" 
  | "Raise Capital" 
  | "Admin"
  | "Settings"
  | "Earn Rewards";

// Map the dashboard items to icons
export const getSidebarIcon = (name: SidebarIconName) => {
  switch (name) {
    case "Dashboard":
      return Home;
    case "Investor Forms":
      return FileText;
    case "Investor Leads":
      return Users;
    case "Campaigns":
      return MessageSquare; 
    case "Raise Capital":
      return CreditCard;
    case "Admin":
      return ShieldCheck;
    case "Settings":
      return Settings;
    case "Earn Rewards":
      return BadgeDollarSign;
    default:
      return FileText;
  }
};
